// 四舍五入截取小数点后两位,并千分位格式化，没有的小数位补0
const formatData = (num, decimal = 0) => {
  num = Number(num);
  if (!num) return `0${decimal > 0 ? "." : ""}${"0".repeat(decimal)}`;
  const result = formatNumber(formatDecimal(num.toFixed(2), decimal));
  return result;
};
// 截取小数点后两位
const formatDecimal = (num, decimal = 0) => {
  num = num.toString();
  let index = num.indexOf(".");
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1);
  } else {
    num = num.substring(0);
  }
  return parseFloat(num).toFixed(decimal);
};
// 小数前的千分位格式化
const formatNumber = num => {
  num = num.toString();
  let numArr = num.split(".");
  if (numArr.length === 1) return Number(num).toLocaleString();
  else {
    return Number(numArr[0]).toLocaleString() + "." + numArr[1];
  }
};
export default formatData;
